import { useEffect, useState } from 'react'

type Props = {
  default?: boolean
  threshold?: number
}

const useIsScrolledToTop = (props: Props) => {
  const [isScrolledToTop, setIsScrolledToTop] = useState(props.default ?? true)
  const threshold = props.threshold ?? 1
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolledToTop(window.pageYOffset < threshold)
    }
    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [threshold])
  return isScrolledToTop
}
export default useIsScrolledToTop
